export const loadNewsletterScript = () => {
  const hasScript = document.getElementById('form-loader');
  if (!hasScript) {
    const script = document.createElement('script');
    script.src =
      'https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007';
    script.async = true;
    script.id = 'form-loader';
    document.body.appendChild(script);
  }
};

export const loadNewsletterTrackingScript = () => {
  const hasScript = document.getElementById('ws-useTracking');
  if (!hasScript) {
    const scriptTracker = document.createElement('script');
    scriptTracker.src =
      'https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007';
    scriptTracker.async = true;
    scriptTracker.id = 'ws-useTracking';
    document.body.appendChild(scriptTracker);
  }
};

// @TODO: msd_subscribe currently does not run with the form-loader script (above) but requires the FormLoader script (below). It does not contain a tracking script. @TODO: msd_subscribe script-use should be aligned with other forms. For this, a new script by IL was requested. (Status August 2024)
export const loadNewsletterScriptMSDSubscribe = () => {
  const hasScript = document.getElementById('FormLoader');
  if (!hasScript) {
    const script = document.createElement('script');
    script.src =
      'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js';
    script.async = true;
    script.id = 'FormLoader';
    document.body.appendChild(script);
  }
};
